import { STRINGS, type Language } from "@mensajeando/ui";
import { useStore } from "../store/store";

export function useLang(): Language {
  return useStore((s) => s.ui.language);
}

export function useT() {
  const lang = useLang();
  return STRINGS[lang];
}
